import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { IThreadCategory, IThreadItem, IThreadListRequestQuery } from '@/api/modules/threads/types'
import { ThreadsApi } from '@/api/modules/threads/api'
import { IRequestQuery } from '@/api/modules/types'

export const useChatHistoryPageStore = defineStore('chatHistoryPageStore', () => {
  const categories = ref<IThreadCategory[]>([])

  const chatHistory = ref<IThreadItem[]>([])
  const countChats = ref<number>(0)

  const categoriesInfoGroupedByCategory = computed((): Record<string, IThreadCategory> => {
    return categories.value.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.category]: { ...curr },
      }),
      {},
    )
  })

  const setCategories = (newCategories: IThreadCategory[]) => (categories.value = newCategories)

  const setChatHistory = (newHistory: IThreadItem[]) => (chatHistory.value = newHistory)

  const getChatHistory = async (params: Partial<IThreadListRequestQuery>) => {
    const { data } = await ThreadsApi.getThreads(params)
    setChatHistory(data?.results || [])
    countChats.value = data?.count || 0
  }

  const getChatCategories = async () => {
    const { data } = await ThreadsApi.getThreadCategories()

    setCategories(data || [])
  }

  return {
    categories,
    chatHistory,
    categoriesInfoGroupedByCategory,
    countChats,

    getChatHistory,
    getChatCategories,
  }
})
